<nz-list *ngIf="datasets" nzGrid>
  <div nz-row [nzGutter]="16">
    <div nz-col *ngFor="let item of datasets; trackBy: trackByRef">
      <nz-list-item>
        <a *ngIf="item.link; else iconCard" [href]="item.link">
          <ng-container *ngTemplateOutlet="iconCard"></ng-container>
        </a>

        <ng-template #iconCard>
          <nz-card class="icon-card">
            <nz-avatar [nzSize]="28" [nzSrc]="item.type"></nz-avatar>
            {{ item.name }}
          </nz-card>
        </ng-template>
      </nz-list-item>
    </div>
  </div>
</nz-list>
